import api from "../api";
import { Notification } from "../types/notification";

export const getNotifications = async (page = 1) => {
    const response = await api.get<{ status: string; data: { data: Notification[], current_page: number, last_page: number } }>(`/notifications?page=${page}`);
    return response.data;
};

export const getUnreadNotificationsCount = async () => {
    const response = await api.get<{ status: string; data: { total: number } }>(`/notifications/unread`);
    return response.data.data.total;
};

export const markAsRead = async (id: string) => {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
};

export const markAllAsRead = async () => {
    const response = await api.post(`/notifications/read-all`);
    return response.data;
};
